import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {
  BokkzJrLogic, ClientEntity, JaarrapportageEntity
} from '@snelstart-ventures/fiscaal/domain-logic';
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import { Observable, Subscriber, Subscription, } from "rxjs";
import { ToastService } from "@snelstart/ui-toast";
import { Router } from "@angular/router";
import {ButtonConfiguration, SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiAlertModule} from "@snelstart/ui-alert";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-accountantsverklaring-genereren',
  templateUrl: './accountantsverklaring-genereren.component.html',
  imports: [
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiAlertModule,
    ReactiveFormsModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./accountantsverklaring-genereren.component.css']
})
export class AccountantsverklaringGenererenComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  public jrEntity = {} as JaarrapportageEntity;
  private clientEntity = {} as ClientEntity

  private routerSubscription: Subscription | undefined;

  public engagementTypeFg = {} as FormGroup;
  public continuiteitFg = {} as FormGroup;
  public nbaAccountantFg = {} as FormGroup;
  public showSpinner = false;

  get isNbaAccountant(): boolean {
    return this.nbaAccountantFg.get('value')?.value ?? false;
  }

  verklaringGenereren = ButtonConfiguration.create({
    onClick: () =>
      new Observable<void>(subscription => {
        this.getGenerateReport(subscription);
      }),
  });

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private jrLogicService: BokkzJrLogic,
    public toastService: ToastService,
    private router: Router,
    private fb: FormBuilder) {
    this.engagementTypeFg = this.fb.group({
      value: 'SAMENSTELLEN'
    });
    this.continuiteitFg = this.fb.group({
      value: false
    });
    this.nbaAccountantFg = this.fb.group({
      value: false
    });
  }

  public ngOnInit(): void {
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.jrEntity = value;
    });
    this.algDataService.client.subscribe((clientEntity) => {
      this.clientEntity = clientEntity;
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
  }

  getGenerateReport(subscription: Subscriber<void>) {
    const engagement = this.engagementTypeFg.get('value')?.getRawValue();
    const uncertaintyAboutGoingConcern = this.continuiteitFg.get('value')?.getRawValue() || false
    const nbaAccountant = this.nbaAccountantFg.get('value')?.getRawValue() || false
    const clientId = String(this.clientEntity.sstRelationId)
    if (this.jrEntity && engagement && clientId) {
        this.jrLogicService.generateAuditorsReport(clientId, this.jrEntity, engagement, uncertaintyAboutGoingConcern, nbaAccountant, subscription);
    }
    this.showSpinner = true;
    setTimeout(() => {
      this.showSpinner = false;
    }, 1000);
  }
}
